import type { ButtonVariant } from "@qendo/theme";
import { type Href, router } from "expo-router";
import { useCallback } from "react";
import { RectButton, type RectButtonProps } from "react-native-gesture-handler";
import { BaseText } from "~/components/layout/text";
import { QendoIcon, type QendoIconSet } from "~/components/QendoIcon";
import { Flex, Gap, Items, Padding, Rounded } from "~/constants/layout";
import { useTheme } from "~/providers/ThemeProvider";
import { filled } from "~/util";

export type HeaderButtonProps = {
    title?: string;
    icon?: QendoIconSet;
    href?: Href;
    variant?: ButtonVariant;
} & RectButtonProps;

export const HeaderButton = ({ title, icon, href, onPress, variant = "quiet", ...buttonProps }: HeaderButtonProps) => {
    const { colours } = useTheme();

    const handlePress = useCallback(
        (pointerInside: boolean) => {
            href && router.navigate(href);
            onPress?.(pointerInside);
        },
        [onPress, href],
    );

    return (
        <RectButton
            {...buttonProps}
            style={[
                Flex.row,
                Flex.center,
                Items.center,
                Rounded.md,
                Gap.xs,
                Padding.xs,
                { backgroundColor: colours.button[`${variant}-background`] },
            ]}
            underlayColor={colours.button[`${variant}-pressed-background`]}
            onPress={handlePress}
        >
            {filled(icon) && <QendoIcon name={icon} color={colours.button[variant]} size={20} />}
            {filled(title) && (
                <BaseText weight="semibold" style={{ color: colours.button[variant] }}>
                    {title}
                </BaseText>
            )}
        </RectButton>
    );
};
